import { render, staticRenderFns } from "./List-Promotion-Offline.vue?vue&type=template&id=2ae5937a&scoped=true"
import script from "./List-Promotion-Offline.vue?vue&type=script&lang=js"
export * from "./List-Promotion-Offline.vue?vue&type=script&lang=js"
import style0 from "./List-Promotion-Offline.vue?vue&type=style&index=0&id=2ae5937a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae5937a",
  null
  
)

export default component.exports